import React, { ReactNode } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Div, Skeleton } from '@pezeshk-book/ui-kit';

const InfiniteScrollLayout = ({ length, hasMore, next, children }: {length: number, hasMore: boolean, next: () => void, children: ReactNode}) => {
  return (
    <div className={'w-full md:w-7/12'}>
      <InfiniteScroll
        className={'flex flex-col items-start w-full gap-4'}
        dataLength={length}
        loader={
          <Div className={'flex-col gap-4 w-full'}>
            <Skeleton shape={'rectangular'} size={'large'} className={'w-full rounded !h-[120px]'} color={'control'}/>
            <Skeleton shape={'rectangular'} size={'large'} className={'w-full rounded !h-[120px]'} color={'control'}/>
            <Skeleton shape={'rectangular'} size={'large'} className={'w-full rounded !h-[120px]'} color={'control'}/>
          </Div>
        }
        hasMore={hasMore}
        next={next}
      >
        {children}
        <Div id={'scrollView'}/>
      </InfiniteScroll>
    </div>
  );
};

export default InfiniteScrollLayout;
